<template>
	<div class="pages">
		<sub-ibox-title>
			<p slot="title">粉丝管理</p>
		</sub-ibox-title>
		<z-tab-bar :list-obj="tabBarParams.list" :active="tabBarParams.active" @handleClickTabBar="handleClickTabBar"></z-tab-bar>
		<section class="content">
			<div class="min-width">
				<z-search v-model="params.search" placeholder="请输入昵称" @handleSearch="handleGetFansList" class="m-b-20"></z-search>
				<h3 class="fx">
					<p class="p-l-20">用户</p>
					<p class="text-center fx-fill">openid</p>
					<p class="text-center">状态</p>
					<p class="text-center">性别</p>
					<p class="text-center">地区</p>
					<p class="text-right p-r-20">关注时间</p>
				</h3>
				<div class="user-list">
					<ul>
						<li  v-for="(item, index) in list.list || []">
							<dl class="fx fx-y-center">
								<dd class="fx fx-y-center">
									<p class="pic-cont"><img :src="item.headimgurl || logo"/></p>
									<div class="user-name text-ellipsis">{{item.nickname || '-'}}</div>
								</dd>
								<dd class="text-center fx-fill">{{item.openid}}</dd>
								<dd class="text-center">{{item.subscribe ? '已关注':'未关注'}}</dd>
								<dd class="text-center">{{item.sex > 1 ? '女' :'男'}}</dd>
								<dd class="text-center"><span v-show="item.country">{{item.country + item.province + item.city}}</span></dd>
								<dd class="user-time text-right">{{item.subscribe_time | momentFmt}}</dd>
							</dl>
						</li>
					</ul>
					<div v-if="list.list.length <= 0">
						<div class="fx-align"><p class="p-20">暂无记录 (˘•ω•˘)</p></div>
					</div>
				</div>
				<div class="fx-y-center pages-cont">
					<z-pages :offset="params.offset" :count="params.count" :total-count="list.item_total || 0" @handleOffset="handleGetFansList"></z-pages>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	import logo from '@/assets/img/logo.png'
	export default {
		name: 'WxMemberList',
		components: {
		},
		data() {
			return {
				logo,
				params: {
					search: null,//用户名称
					offset: 0, //分页偏移量
					count: 10 //每页多少条
				},
				tabBarParams:{
					list:[{
						title:'粉丝分析',
						type:'fansCount'
					},{
						title:'粉丝列表',
						type:'fansList'
					}],
					active:'fansList' //默认
				},
			}
		},
		mounted (){
			this.handleGetFansList()
	    },
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				list: state => state.fans.list
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			handleClickTabBar(type) { //切换tabbar
				if(type=="fansList"){
					this.$router.replace({ name: 'wxMemberList' })
				}else{
					this.$router.replace({ name: 'wxMember' })
				}
			},
			handleGetFansList(offset = 0){//获取粉丝列表
				this.$log(offset)
				this.params.offset = offset
				this.getFansList(this.params)
			},
			...mapActions(['getFansList']),
		}
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.content {
		width: 100%;
		overflow-x: auto;
		h3{
			background:$color-lightgray;
			padding: px-em(20px);
			p{
				width: 16%;
			}
		}
		.user-list li{
			padding: px-em(20px);
			border-top: 1px solid $color-border;
			transition:all 0.3s ease; 
			&:hover{
				background: rgba(0,0,0,0.05);
			}
			.pic-cont{
				width: px-em(70px);
				height: px-em(70px);
				overflow: hidden;
				border: 1px solid $color-border;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.user-name{
				width: px-em(280px);
				color: $color-font;
				height: px-em(70px);
				line-height: px-em(70px);
				padding-left: px-em(30px);
				
			}
			.user-time{
				color: $color-font-sub;
			}
			dd{
				color: $color-font-sub;
				width: 16%;
			}
		}
		.pages-cont{
			padding-top: px-em(40px);
			border-top: 1px solid $color-border;
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.min-width{
			min-width: px-em(1600px);
			padding-right: px-em(40px);
		}
		.user-name{
			width: px-em(300px);
		}
	}
</style>



// WEBPACK FOOTER //
// WxMemberList.vue?569c37c2